import { render, staticRenderFns } from "./MonthlyComparisonCard.vue?vue&type=template&id=109c9998&scoped=true&"
import script from "./MonthlyComparisonCard.vue?vue&type=script&lang=js&"
export * from "./MonthlyComparisonCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109c9998",
  null
  
)

export default component.exports